import React, { createContext, useContext, useState, useMemo } from 'react';

const DarkModeContext = createContext();

export const DarkModeProvider = ({ children }) => {
	const [darkMode, setDarkMode] = useState(() => localStorage.getItem('adminDarkMode') === 'true');

	const toggle = () => {
		setDarkMode(prev => {
			const next = !prev;
			localStorage.setItem('adminDarkMode', String(next));
			return next;
		});
	};

	const value = useMemo(() => ({ darkMode, toggle }), [darkMode]);
	return <DarkModeContext.Provider value={ value }>{ children }</DarkModeContext.Provider>;
};

export const useDarkMode = () => useContext(DarkModeContext);
